import React, {useState} from 'react';
import SignUpForm from "../../components/forms/SignUpForm";
import AccountsSelector from "../../components/forms/AccountSelector";
import LoginFormOTPVerification from "../../components/forms/LoginFormOTPVerification";
import LoginFormPassword from "../../components/forms/LoginFormPassword";
import logo from "../../assets/imgs/zing_white_logo.png";
import LoginForm from "../../components/forms/LoginForm";
import BarLoader from "../../components/BarLoader";
import {isAllowed} from "../../helpers/authenticator";


const Account = ({route}) => {
    let states = [];
    if (route.id === "signin") {
        states = ["signin", "verification", "password", "redirect"];
    } else {
        states = ["loginType", "register", "verification", "redirect"];
    }

    const [change, setChange] = useState({
        isActive: false,
        componentType: route.id === "signin" ? "signin" : "loginType",
        phone: "", refId: ""
    });
    const [isButtonClicked, setButtonClick] = useState(false)


    //These are used in the verification process
    const hasChangedComponentCallback = ({isActive, componentType, phone, refId}) => {
        if (isAllowed()) {
            window.location.href = "/home";
        } else {
            setChange({isActive: isActive, componentType: componentType, phone: phone, refId: refId});
        }
    };

    const onButtonCallback = (state) => {
        setButtonClick(state)
    };

    const setPreviousState = ({currentState, state, phone, refId}) => {
        let index = states.indexOf(currentState);
        let newIndex = index - 1;
        if (newIndex >= 0) {
            setChange({isActive: state, componentType: states[newIndex], phone: phone, refId: refId});
        }
    };


    const view = ({state, componentType}) => {
        switch (componentType) {
            case "register":
                return <SignUpForm change={{
                    current: change,
                    callback: hasChangedComponentCallback,
                    isClicked: isButtonClicked,
                    buttonCallback: onButtonCallback
                }}/>;
            case "signin":
                return <LoginForm change={{
                    current: change,
                    callback: hasChangedComponentCallback,
                    isClicked: isButtonClicked,
                    buttonCallback: onButtonCallback
                }}/>;
            case "loginType":
                return <AccountsSelector change={{current: change, callback: hasChangedComponentCallback}}/>;
            case "verification":
                return <LoginFormOTPVerification change={{current: change, callback: hasChangedComponentCallback}}/>;
            case "password":
                return <LoginFormPassword change={{current: change, callback: hasChangedComponentCallback}}/>;
            case "loading":
                return <BarLoader/>;
            default:
                return <AccountsSelector change={{callback: hasChangedComponentCallback}}/>;
        }
    };

    return (
        <div className="main-wrapper">
            <div className="">
                <div className="row no-gutters">
                    <div className="col-md-3">
                        <div className="sider">
                            <a className="navbar-brand" href="/">
                                <img src={logo} className="img-fluid logo"/>
                            </a>

                            <ul className="list-unstyled sider-text">
                                <li><h2 className="header-text">
                                    Your packages delivered securely
                                </h2></li>
                                <li>
                                    <p>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                        incididunt ut labore et dolore magna aliqua.
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-md-9">
                        <div className="main">
                            <div className="center-block align-middle">
                                <div className="container">
                                    {view(change)}
                                </div>
                            </div>
                            <div className="bottom-block">
                                <div className="container">
                                    <div className="row justify-content-center">
                                        <div className="col-3 col-md-3 text-left">
                                            <button className="btn btn-secondary btn-md"
                                                    onClick={() => setPreviousState({
                                                        currentState: change.componentType,
                                                        isActive: true,
                                                        phone: change.phone,
                                                        refId: change.refId
                                                    })}>
                                                Previous
                                            </button>
                                        </div>
                                        <div className="col-6 col-md-6 text-center align-self-center">
                                            <p>Having troubles? <span>Get Help</span></p>
                                        </div>
                                        <div className="col-3 col-md-3 text-right">
                                            <button className="btn btn-primary btn-md"
                                                    onClick={() => setButtonClick(true)}>
                                                Next
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/*<Header/>*/}
        </div>
    )
};


export default Account;
